import { render, staticRenderFns } from "./QuotaTariff.vue?vue&type=template&id=68832795&"
import script from "./QuotaTariff.vue?vue&type=script&lang=js&"
export * from "./QuotaTariff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports